
import {createRouter,createWebHashHistory} from "vue-router"
import play from "../components/VideoPlayer.vue"   //引入路由组件
 
const router = createRouter({   //createRouter   vue2中是 new Vue
	history : createWebHashHistory(),  //createWebHashHistory  ，v3文档 API里有 ，将模式修改 ，Vue2中是mode :history
	routes: [
        // {  //配置路由规则
		// 	name: 'play',
		// 	path: '/', //默认路径
		// 	component: Home
		// },
 
		{
			name: 'play',
			path: '/play',
			component: ()=> import('../components/VideoPlayer.vue')  //动态路由的写法
		}
		// {
		// 	name: 'play',
		// 	path: '/play',
		// 	component: ()=> import('../components/HelloWorld.vue')  //动态路由的写法
		// }
	]
})
 
 
export default router